import React from 'react';
import { Tooltip as AntTooltip } from 'antd';

const DEFAULT_TOOLTIP_PLACEMENT = 'top';
const VALID_TOOLTIP_PLACEMENTS = [
  DEFAULT_TOOLTIP_PLACEMENT,
  'left',
  'right',
  'bottom',
  'topLeft',
  'topRight',
  'bottomLeft',
  'bottomRight',
  'leftTop',
  'leftBottom',
  'rightTop',
  'rightBottom'
];

const Tooltip = ({
  children,
  content,
  trigger = 'hover',
  mouseEnterDelay = 0.5,
  mouseLeaveDelay = 0,
  title,
  placement = DEFAULT_TOOLTIP_PLACEMENT,
  color = 'var(--greyscale-white)',
  defaultOpen = false,
  destroyOnHidden = true
}) => {
  // Check if the placement is valid, if not, use the default 'top' placement
  const validatedPlacement = VALID_TOOLTIP_PLACEMENTS.includes(placement) ? placement : DEFAULT_TOOLTIP_PLACEMENT;

  return (
    <AntTooltip
      trigger={trigger}
      mouseEnterDelay={mouseEnterDelay}
      mouseLeaveDelay={mouseLeaveDelay}
      content={content}
      title={title}
      placement={validatedPlacement}
      color={color}
      classNames={{ root: 'oqio-tooltip' }}
      defaultOpen={defaultOpen}
      destroyOnHidden={destroyOnHidden}
    >
      {children} {''}
    </AntTooltip>
  );
};

export default Tooltip;
